import React from 'react'

import { PositionTemplateManagementModal } from 'components/modals/PositionTemplateManagementModal/PositionTemplateManagementModal'
import { TemplateBasedJobPositionModal } from 'components/modals/TemplateBasedJobPositionModal/TemplateBasedJobPositionModal'
import { Loader } from 'components/shared/Loader/Loader'
import { NoSearchResults } from 'components/shared/NoSearchResults/NoSearchResults'
import { Pane } from 'components/shared/Pane/Pane'
import { JobDetailsContent } from './common/JobDetailsContent/JobDetailsContent'

import { useJobTemplateDetails } from './hooks'

import styles from './JobDetails.module.scss'

export const JobDetails = () => {
  const { state, handlers } = useJobTemplateDetails()

  const {
    language,
    template,
    hasCategories,
    isLoading,
    isEditJobTemplateOpen,
    isTemplateBasedJobPositionOpen,
  } = state
  const {
    handleBack,
    handleEditJobTemplateClose,
    handleEditJobTemplateConfirm,
    handleEditJobTemplateOpen,
    handleTemplateBasedJobPositionClose,
    handleTemplateBasedJobPositionOpen,
    handleTemplateBasedJobPositionConfirm,
  } = handlers

  return (
    <>
      <Pane className={styles.details}>
        {isLoading ? (
          <Loader isInline />
        ) : template?.ok ? (
          <JobDetailsContent
            onEdit={handleEditJobTemplateOpen}
            onAddJob={handleTemplateBasedJobPositionOpen}
            onBack={handleBack}
            {...{ ...template, language, hasCategories }}
          />
        ) : (
          <NoSearchResults />
        )}
      </Pane>
      <PositionTemplateManagementModal
        onCancel={handleEditJobTemplateClose}
        onClose={handleEditJobTemplateClose}
        onConfirm={handleEditJobTemplateConfirm}
        isOpen={isEditJobTemplateOpen}
        {...{ template }}
      />
      <TemplateBasedJobPositionModal
        onCancel={handleTemplateBasedJobPositionClose}
        onClose={handleTemplateBasedJobPositionClose}
        onConfirm={handleTemplateBasedJobPositionConfirm}
        isOpen={isTemplateBasedJobPositionOpen}
        {...{ template }}
      />
    </>
  )
}
